import { makeStyles, createStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme =>
  createStyles({
    autoCompleteUnderline: {
      "&:before": {
        border: ["none", "!important"],
      },
    },
    searchMenuPaper: {
      width: 500,
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
      height: 350,
    },
    searchMenuItemPaper: {
      marginRight: [0, "!important"],
      marginBottom: theme.spacing(2),
      "&:last-of-type": {
        marginBottom: 0,
      },
    },
    searchMenuAutoComplete: {
      width: "100%",
    },
    filterMenuPaper: {
      width: 240,
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
    filterMenuItem: {
      display: "flex",
      justifyContent: "space-between",
    },
    arrowIcon: {
      width: "0.8em",
      transition: theme.transitions.create("transform", {
        easing: theme.transitions.easing.sharp,
      }),
    },
    arrowDown: {
      transform: "rotate(180deg)",
    },
    arrowOut: {
      transform: "scale(0)",
    },
    customStyleOnActiveTab: {
      color: theme.palette.primary.dark,
    },
    activeTab: {
      fontSize: "14px",
      fontWeight: "500",
      color: theme.palette.primary.dark,
    },
  })
)

export default useStyles
